import { intl } from "@fidget/common/i18n";
import React, { useState } from "react";
import { IAgentGroup } from "../../../models/agentGroups/agentGroup";
import { AddDeleteAgentGroupPicker } from "../../forms/addDeleteAgentGroupPicker";
import { ListActionLabel } from "./listActionLabel";
import styles from "./listActions.css";
interface Props {
  text?: string;
  values: IAgentGroup[];
  onAdded: (group: IAgentGroup) => void;
  onDeleted: (group: IAgentGroup) => void;
}
export const ListAddDeleteAgentGroupAction = ({
  text = intl.formatMessage("agentGroupAddDeletePicker.placeholder"),
  onAdded,
  onDeleted,
  values
}: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  return isPicking ? (
    <AddDeleteAgentGroupPicker
      className={styles["action-dropdown-agent-groups"]}
      values={values}
      onAdded={(group) => {
        onAdded(group);
        setIsPicking(false);
      }}
      onDeleted={(group) => {
        onDeleted(group);
        setIsPicking(false);
      }}
      onClose={() => setIsPicking(false)}
      initialIsOpen
    />
  ) : (
    <ListActionLabel text={text} onClick={() => setIsPicking(true)} />
  );
};
